import { render } from "./UpdateSurveyModal.vue?vue&type=template&id=4e70dc4e&scoped=true"
import script from "./UpdateSurveyModal.vue?vue&type=script&lang=js"
export * from "./UpdateSurveyModal.vue?vue&type=script&lang=js"

import "./UpdateSurveyModal.vue?vue&type=style&index=0&id=4e70dc4e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e70dc4e"]])

export default __exports__